<template>
  <div class="container">
    <section class="w1380">
      <nav>当前位置：<a @click="toArticle">文献</a> > 文献详情</nav>
      <div class="main flex">
        <div class="info-left">
          <div class="info-loading" v-loading="loading">
            <div class="info" v-if="detail">
              <h2>
                <span v-safe-html="detail.title"></span>
                <img v-if="detail.source == '馆藏资源'" src="../../assets/images/icon-gc.png" />
                <!-- <label :class="getColor(detail.oaType)" v-safe-html="getoatext(detail.oaType)"></label> -->
              </h2>
              <p class="fanyi" v-if="detail.title">
                <el-button type="text" @click="closeTranslate1" v-if="translatetitle">收起</el-button>
                <el-button v-else :loading="translateLoading1" type="text" @click="toTranslatetitle(detail.title)">MT翻译</el-button>
              </p>
              <p>
                {{ translatetitle }}
              </p>
              <p class="titleCn">{{ detail.titleCn }}</p>
              <p v-if="detail.author && detail.author.length > 0">
                <span class="info-author">
                  作者:
                  <span class="span-content" :class="{ green_span: item.click }" v-for="(item, index) in detail.author" :key="index">
                    <span class="span_a" @click="toAuthorDetail(item)">{{ item.authorName }}</span>
                    <label v-if="index < detail.author.length - 1">;</label>
                    <div class="author-content">
                      <p class="mb10" v-safe-html="item.authorName"></p>
                      <p>
                        <span v-if="item.hindex != null"
                          >hindex：<label>{{ item.hindex }}</label></span
                        >
                        <span v-if="item.i10Index != null"
                          >i10Index：<label>{{ item.i10Index }}</label></span
                        >
                      </p>
                      <p>
                        <span v-if="item.citedByCount != null"
                          >citedByCount：<label>{{ item.citedByCount }}</label></span
                        >
                        <span v-if="item.worksCount != null"
                          >worksCount：<label>{{ item.worksCount }}</label></span
                        >
                      </p>
                      <p class="hui">{{ item.lastKnownInstitutionName }}</p>
                    </div>
                  </span>
                </span>
              </p>
              <p v-if="detail.journalName">
                期刊信息:
                <span class="journal_span">
                  <label class="green" @click="toJournalDetail">{{ detail.journalName }}</label
                  >; {{ detail.year }}<font v-if="detail.year && detail.volumeInfo">;</font> {{ detail.volumeInfo }}</span
                >
              </p>
              <p v-if="detail.doi">DOI: {{ detail.doi }}</p>
              <!-- <p>
            <span class="mr15" v-if="detail.year">年: {{ detail.year }}</span>
            <span class="mr15" v-if="detail.volume">卷: {{ detail.volume }}</span>
            <span v-if="detail.issue">期: {{ detail.issue }}</span>
          </p> -->

              <!-- <p v-if="detail.volumeInfo">
              <span>卷期描述: {{ detail.volumeInfo }}</span>
            </p> -->
              <p>
                <span class="mr15" v-if="detail.publishName"> 出版社: {{ detail.publishName }} </span>
                <span v-if="detail.publishDate">出版日期: {{ detail.publishDate }}</span>
              </p>
              <p>
                <span class="mr15" v-if="detail.publishCountry"> 国别: {{ detail.publishCountry }} </span>
                <span class="mr15" v-if="detail.hierarchy"> 文献类型: {{ getString(detail.hierarchy) }} </span>
                <span class="mr15" v-if="detail.language"> 语种: {{ detail.language }} </span>
                <!-- <span v-if="detail.pageInfo">页码: {{ detail.pageInfo }}</span> -->
              </p>
              <p v-if="detail.hingeWord">
                关键词:
                <span v-for="(item, index) in detail.hingeWordArray" :key="index">
                  <span class="green keyword_span" @click="toArticleSearch(item)">{{ item }}</span>
                  <label v-if="index < detail.hingeWordArray.length - 1">; </label>
                </span>
              </p>
              <p v-if="detail.fund">所属基金项目: {{ detail.fund }}</p>
              <p v-if="detail.subjectNames.length > 0">
                学科分类:
                {{ getString(detail.subjectNames) == "未分类" ? detail.subjectInfo : getString(detail.subjectNames) }}
              </p>
              <p v-if="detail.detailUrl">
                文章详情链接:
                <a :href="detail.detailUrl" target="_bank" class="green hover_a">{{ detail.detailUrl }}</a>
              </p>
              <!-- <p>
                <span class="mr15" v-if="detail.thesaurus"> 主题词: {{ getString(detail.thesaurus) }} </span>
                <span v-if="detail.citationReport"> 核心期刊: {{ detail.citationReport }} </span>
              </p> -->
              <p>
                <span class="mr15" v-if="detail.isOa"> 是否OA: {{ detail.isOa == 20 ? "是" : "否" }} </span>
                <span v-if="detail.isInDoaj"> isInDoaj: {{ detail.isInDoaj == 1 ? "TRUE" : "FALSE" }} </span>
                <span v-if="detail.subjectPart"> 学科分区: {{ detail.subjectPart }} </span>
              </p>
              <!-- <p v-if="detail.academyScience">中科院核心期刊: {{ detail.academyScience }}</p>
            <p v-if="detail.dbRecord">数据库收录: {{ getString(detail.dbRecord) }}</p>
            <p v-if="detail.fund">所属基金项目: {{ getString(detail.fund) }}</p>
            <p v-if="detail.clc">中图法分类号: {{ getString(detail.clc) }}</p>

            <p v-if="detail.secondSubject">外文学科分类: {{ detail.secondSubject }}</p> -->
              <!-- <p v-if="detail.foreignSubjectInfo">
              文章详情链接: {{ detail.foreignSubjectInfo }}
            </p> -->
              <!-- <p v-if="detail.type">获取方式: {{ detail.type }}</p> -->
              <p v-if="detail.digest">
                摘要: <span v-safe-html="detail.digestStr"></span>
                <label class="green more-a" @click="getMore" v-if="detail.digestStr.length > 210 && !moreFlag">更多</label>
                <label class="green more-a" @click="removeMore" v-if="moreFlag">收起</label>
              </p>
              <p class="fanyi" v-if="detail.digest"><el-button type="text" @click="closeTranslate" v-if="translatePaper">收起</el-button><el-button v-else :loading="translateLoading" type="text" @click="toTranslate">MT翻译</el-button></p>
              <p>
                {{ translatePaper }}
              </p>
              <!-- <p v-if="detail.source">来源: {{ detail.source }}</p> -->
              <!-- <div class="btnList">
              <el-button type="primary" v-show="qwshow" @click="getResource(detail)">全文获取</el-button>
              <el-button v-if="!resultFlag" @click="isCollect"><i class="el-icon-star-off"></i>收藏</el-button>
              <el-button type="primary" v-else @click="isCollectTips"><i class="el-icon-star-off"></i>取消收藏</el-button>
            </div> -->
            </div>
            <!-- 温馨提示 -->
            <!-- <div class="wxTips" v-if="wxFlag">
              <i class="el-icon-warning"></i>温馨提示：文献题录信息已复制
              ，请至<a @click="handleHelp" >学术论坛</a>发布文献求助获取 -->
            <!-- <i class="el-icon-close" @click="wxFlag = false"></i>
            </div>  -->

            <div class="btnList" v-if="detail">
              引用量<span>{{ detail.citedCount }}</span>
              <div class="btn-right">
                <div class="flex relative">
                  <div class="flex article-action-active" @click="getResource(detail)" :class="{ noCourse: btnLoading }" v-if="roles && detail.gainLiteratureState === true && detail.source !== '商业资源' && detail.shelve !== 1">
                    <img class="rotating-image" v-if="btnLoading" src="../../assets/images/loading_s.svg" />
                    <img class="img" src="../../assets/images/icon-qwhq-mr.png" alt="" />
                    <img class="hover-img" src="../../assets/images/icon-qwhq-xz.png" alt="" />
                    全文获取
                  </div>

                  <div class="achieve" v-if="Resourcelist == detail.openAlexId" v-loading="achieveloading" ref="showPanel">
                    <div class="achieve-li">
                      <li v-for="(bookitem, index) in liblist" :key="index" class="1">
                        <a v-safe-html="bookitem.shortName" @click="libdetailUrl(bookitem)"></a>
                      </li>
                      <li v-if="gainResource.provideType == '3'" @click="recommendrecord(detail)">
                        <a>推荐</a>
                      </li>
                      <li v-if="gainResource.provideType == '2'" @click="getResourceDetail(detail)">
                        <a>单篇采选</a>
                      </li>
                      <li v-if="gainResource.provideType == '1'" @click="getDeliverSave(detail)">
                        <a>文献传递</a>
                      </li>
                      <li v-if="gainResource.provideType == '5'" @click="getLiterature(detail)">
                        <a>请求获取</a>
                      </li>
                      <li v-if="paperData.baiduXueShuExist">
                        <a @click="goBaidu(paperData.baiduXueShuLink)">百度学术</a>
                      </li>
                      <li v-if="qingqiuhuoqu">
                        <a @click="getQingqiu(detail)">请求获取</a>
                        <!-- <font><i class="el-icon-info"></i>我们在一天内进行处理，请您稍后重新打开界面获取。</font> -->
                      </li>
                      <!-- <ul v-if="gainResource.provideType == '1'">
                      <li v-for="(wxitem, index) in remmendlist" :key="index">
                        <a v-if="wxitem.name != '文献获取'" v-safe-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                        <a v-if="wxitem.name == '文献获取' && item.doi" v-safe-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                        <span v-if="wxitem.name == '文献获取'"><i class="el-alert__icon el-icon-warning"></i>一般十分钟获取全文</span>
                        <span v-if="wxitem.name == '百度学术'"><i class="el-alert__icon el-icon-warning"></i>每天免费申请两次</span>
                      </li>
                    </ul> -->
                    </div>
                  </div>
                </div>
                <div class="flex article-action-active" @click="toAi" v-if="!info.ipUser"><img class="active-img" src="../../assets/images/icon-aiqwjx-xz.png" alt="" />AI全文解析</div>
                <div class="flex article-action-active" @click="copylist">
                  <img class="img" src="../../assets/images/icon-fz-mr.png" alt="" />
                  <img class="hover-img" src="../../assets/images/icon-fz.png" alt="" />复制
                </div>
                <div class="flex article-action-active" @click="showReference">
                  <img class="img" src="../../assets/images/icon-yy-mr.png" alt="" />
                  <img class="hover-img" src="../../assets/images/icon-yy-xz.png" alt="" />引用
                </div>
                <div class="flex collect-action" :class="{ checked: detail.share }" @click="getFolderList(detail.sid)" v-if="!info.ipUser">0 {{ detail.share ? "已收藏" : "收藏" }}</div>
                <div class="flex article-action-active" v-if="detail.isPdf && detail.isOa == 20" @click="toPdf"><img class="pdf_img" src="../../assets/images/pdf-xz.png" alt="" />阅读PDF</div>
                <!-- <div class="flex" v-if="detail.isPdf != 0" @click="handleHelp"><img class="pdf_img" src="../../assets/images/pdf.png" alt="" />我要求助</div> -->
              </div>
            </div>
          </div>

          <!-- 文献 -->
          <div class="wx-content">
            <ul class="tabs">
              <li :class="{ checked: tab2Index == index }" v-for="(item, index) in tab2List" :key="index" @click="handleChangeTab2(index)">
                {{ item }}
              </li>
            </ul>
            <!-- 文献网络 -->
            <div class="wx-loading" v-show="tab2Index == 0" v-loading="tab2Loading">
              <div class="relation-one" v-if="citeBoList && citeBoList.length > 0">
                <div>
                  <img class="zuojiantou" src="../../assets/images/jiantou01.png" />
                  <span @click="handSpan(3)" :class="[{ checked: spanIndex == 3 }, { noCursor: citeBoList[2].count == 0 }]" class="cheng">共引文献({{ citeBoList[2].count }})</span>
                </div>
                <div class="flex">
                  <span @click="handSpan(5)" :class="[{ checked: spanIndex == 5 }, { noCursor: citeBoList[4].count == 0 }]" class="qianlv">二级参考文献({{ citeBoList[4].count }})</span>
                  <img src="../../assets/images/jiantou03.png" />
                  <span @click="handSpan(1)" :class="[{ checked: spanIndex == 1 }, { noCursor: citeBoList[0].count == 0 }]">参考文献({{ citeBoList[0].count }})</span>
                  <img src="../../assets/images/jiantou03.png" />
                  <span class="noCursor">节点文献</span>
                  <img src="../../assets/images/jiantou03.png" />
                  <span @click="handSpan(2)" :class="[{ checked: spanIndex == 2 }, { noCursor: citeBoList[1].count == 0 }]">引证文献({{ citeBoList[1].count }})</span>
                  <img src="../../assets/images/jiantou03.png" />
                  <span @click="handSpan(6)" :class="[{ checked: spanIndex == 6 }, { noCursor: citeBoList[5].count == 0 }]">二级引证文献({{ citeBoList[5].count }})</span>
                </div>
                <div>
                  <span class="cheng" @click="handSpan(4)" :class="[{ checked: spanIndex == 4 }, { noCursor: citeBoList[3].count == 0 }]">同被引文献({{ citeBoList[3].count }})</span>
                  <img class="youjiantou" src="../../assets/images/jiantou02.png" />
                </div>
              </div>
              <div class="relation-two" v-if="workReferenceDetail && timeScrollList && timeScrollList.length > 0">
                <TimeScroll :timeScrollList="timeScrollList" :paperYear="workReferenceDetail.paperYear" @childrenValue="childrenValue"></TimeScroll>
              </div>
              <div class="relation-three" v-if="reWorkDataBoList && reWorkDataBoList.length > 0">
                <h3>{{ referenceName }}({{ referenceTotal }})</h3>
                <ul>
                  <li v-for="(item, index) in reWorkDataBoList" :key="index">
                    <p @click="toDetail(item)" v-safe-html="item.workTitle"></p>
                    <p v-if="item.authorArray && item.authorArray.length > 0">
                      <span class="span-content" :class="{ green_span: element.click }" v-for="(element, index) in item.authorArray" :key="index">
                        <span class="span_a" @click="toAuthorDetail(element)" v-safe-html="element.authorName"></span>
                        <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
                        <div class="author-content">
                          <p class="mb10" v-safe-html="element.authorName"></p>
                          <p>
                            <span v-if="element.hindex != null"
                              >hindex：<label>{{ element.hindex }}</label></span
                            >
                            <span v-if="element.i10Index != null"
                              >i10Index：<label>{{ element.i10Index }}</label></span
                            >
                          </p>
                          <p>
                            <span v-if="element.citedByCount != null"
                              >citedByCount：<label>{{ element.citedByCount }}</label></span
                            >
                            <span v-if="element.worksCount != null"
                              >worksCount：<label>{{ element.worksCount }}</label></span
                            >
                          </p>
                          <p class="hui">
                            {{ element.lastKnownInstitutionName }}
                          </p>
                        </div>
                      </span>
                      <label v-if="item.showauthor && item.authorAllArray.length > 5" class="digestLabel" @click="showauthor(index)">展开</label>
                      <label v-if="!item.showauthor" class="digestLabel" @click="closeauthor(index)">收起</label>
                    </p>
                    <div class="num">
                      <span>
                        被引量：<label>{{ item.citedCount }}</label>
                      </span>
                      <span>发表：{{ item.year }}年</span>
                    </div>
                  </li>
                </ul>
                <p class="more" @click="moreData" v-if="reWorkDataBoList.length < referenceTotal && !moreArticleFlag">查看更多</p>
              </div>
            </div>

            <!-- 知识点 -->
            <div class="atlasTree" v-if="tab2Index == 1">
              <el-tree v-if="detail.openAlexId" ref="tree" :data="treeData" :props="defaultProps" :default-expand-all="true"></el-tree>
              <p class="noData" v-else>暂无数据</p>
            </div>
          </div>
        </div>
        <!-- 文献结束 -->
        <div class="info-right-loading" v-loading="loading">
          <div class="info-right" v-if="detail && detail.reJournalBo">
            <p class="name">所属期刊:</p>
            <div class="img">
              <img :src="detail.reJournalBo.cover ? imgUrl + detail.reJournalBo.cover : defaultImg" />
            </div>
            <p class="title" @click="toHomeDetail(detail.reJournalBo.sid)">
              {{ detail.reJournalBo.name }}
            </p>
            <p v-if="detail.reJournalBo.issn">
              ISSN:
              {{ detail.reJournalBo.issn }}
            </p>
            <p v-if="detail.reJournalBo.publisherName">出版社: {{ detail.reJournalBo.publisherName }}</p>
            <p class="name mt10" v-if="topicsList.length > 0">相关Topics:</p>
            <ul class="topic">
              <li v-for="(item, index) in topicsList" :key="index" @click="toTopicDetail(index)">
                {{ item.topicName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <state-dialog :stateVal="state" :dialogVisible="stateDialogVisible" :bodyItemDialog="bodyItem" @closeDialog="closeDialog"></state-dialog>
    <el-dialog title="引用" :visible.sync="referenceDialog" width="30%">
      <div class="dialog-content">
        <ul class="dialog-tab">
          <li @click="changeDialogTab(1)" :class="{ dialogChecked: dialogIndex == 1 }">BIB</li>
          <li @click="changeDialogTab(2)" :class="{ dialogChecked: dialogIndex == 2 }">CITE</li>
        </ul>
        <div class="tab1" v-if="dialogIndex == 1">
          <ul>
            <li>
              <p class="flex">
                <span @click="copyContent(BIBObj)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">{{ BIBObj }}</div>
            </li>
          </ul>
        </div>
        <div class="tab1" v-if="dialogIndex == 2">
          <ul>
            <li v-for="(item, index) in CITEArray" :key="index">
              <p class="flex line">
                <label>{{ item.name }}</label>
                <span @click="copyContent(item.value)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">
                {{ item.value }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="down-dialog-footer">
        导出为
        <span @click="handleExport('bib')">BibTex</span>
        <span @click="handleExport('endnote')">EndNote</span>
      </span>
    </el-dialog>
    <el-dialog title="收藏" :visible.sync="addFodlerDialog" width="25%" class="add_folder_dialog">
      <div class="add_dialog_folder" ref="myScroll">
        <ul>
          <li v-for="(item, index) in folderList" :key="index">
            <div class="div_folder li_folder" v-if="!item.addFlag" @click="handleChoiseFolder(index)">
              <div><img src="../../assets/images/icon-wjj-mr.png" />{{ item.name }}</div>
              <!-- <span v-if="item.exist">已存在</span> -->
              <i class="el-icon-check" v-if="folderIndex === index || (!checkFolder && item.exist)"></i>
            </div>
            <div class="div_folder new_folder" v-else>
              <img src="../../assets/images/icon-wjj-xz.png" alt="" />
              <el-input placeholder="请输入文件夹名称" v-model="item.name" maxlength="20" @keyup.enter.native="submitAddFolder($event)"></el-input>
              <span @click.stop="cannalFolder()"><i class="el-icon-close"></i></span>
              <span><i class="el-icon-check" @click.stop="submitAddFolder($event)"></i></span>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <p @click="newAddFolder"><i class="el-icon-folder-add"></i>新建文件夹</p>
        <div>
          <el-button @click="addFodlerDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitFolder">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 我要求助 友好弹框 -->
    <el-dialog class="helpDialog" title="友情提示" :visible.sync="centerDialogVisible" width="28%">
      <div class="tipsDialog">
        <p>您即将跳转至文献互助平台，相关内容和服务均由该平台提供。 如有文献全文上传，平台将保留 7 天，到期后自动删除并失效。</p>
        <p>请您自行甄别与判断，相关风险由您自行承担。</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureHelp">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="绑定手机号" :visible.sync="phoneDialog" width="25%">
      <el-input placeholder="请输入手机号" v-model="phone" maxlength="20" @keyup.enter.native="submitAddphone($event)" class="phone-input"></el-input>
      <div class="flex phone">
        <el-input placeholder="验证码" v-model="code" />
        <span class="code" v-if="show" @click="getCode">发送验证码</span>
        <span class="code" v-else>{{ times }}</span>
      </div>
      <div class="flex phonebtn">
        <el-button @click="phoneDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddphone">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请求获取文献" :visible.sync="literatureDialogVisible" width="420px" :before-close="handleLiteratureClose">
      <div class="literature-dialog-content">
        <p class="literature-tip-sm">声明：请求的文献仅用于科研与教学使用，不做非法传播、复制</p>
        <p class="literature-tip">请正确输入邮箱，文献请求获取结果会以邮箱方式通知!</p>

        <el-form :model="literatureForm" :rules="literatureRules" ref="literatureFormRef">
          <el-form-item prop="email">
            <el-input v-model="literatureForm.email" placeholder="请输入邮箱地址" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer-right">
        <el-button @click="handleLiteratureClose">取 消</el-button>
        <el-button type="primary" @click="submitLiterature">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
import StateDialog from "@/components/state_dialog.vue";
import TimeScroll from "@/components/timeScroll.vue";
import * as echarts from "echarts";
import { oaColor, oaText } from "../../assets/js/oacolor";
import Axios from "axios";
export default {
  name: "HomeDetail",
  components: { StateDialog, TimeScroll },
  data() {
    return {
      loading: false,
      tab2Loading: false,
      sid: "",
      doi: "",
      detail: null,
      imgUrl: "",
      state: 0,
      stateDialogVisible: false,
      bodyItem: null,
      resultFlag: false,
      defaultImg: require("../../assets/images/default.png"),
      roles: true,
      referenceUrlList: [],
      refIndex: 0,
      tab1List: [],
      tab1Index: 0,
      tab2List: ["文献网络", "知识点"],
      tab2Index: 0,
      authorList: [],
      workDataBoList: [], //文献列表
      paperLoading: false, //文献loading
      restList: [], //文献更多
      paperType: 10, //文献类型
      restWorkBoList: [], //引证文献 更多列表
      remmend: false,
      remmendlist: [],
      achieveloading: true,
      Resourcelist: false,
      detaildoi: "",

      topicsList: [],
      displayshow: false,
      nodenum: false,
      liblist: [],
      Paperstate: "",
      gainResource: {},
      moreFlag: false,
      collectFalse: require("../../assets/images/icon-sc-mr.png"),
      collectTrue: require("../../assets/images/icon-sc-xz.png"),
      defaultProps: {
        children: "children",
        label: "displayName",
      },
      treeData: [],
      referenceDialog: false,
      dialogIndex: 1,
      BIBObj: null,
      CITEArray: [],
      qingqiuhuoqu: false,
      translatePaper: "", //翻译内容
      translateLoading: false,
      translateLoading1: false,
      translatetitle: "", //翻译标题
      btnLoading: false,
      spanIndex: 7,
      //文献网络
      workReferenceDetail: null,
      citeBoList: [],
      timeScrollList: [],
      realYear: "",
      reWorkDataBoList: [], //文献列表
      restList: [], //剩余更多文献集
      referenceName: "",
      referenceTotal: 0,
      moreArticleFlag: false,
      info: null,
      //文件夹
      addFodlerDialog: false,
      folderList: [],
      folderIndex: null,
      checkFolder: false,
      foldershare: false,
      translatetitle: "",

      authorNameStr: null,
      centerDialogVisible: false,
      // 是否显示文献互助平台提示
      wxFlag: false,
      phoneDialog: false,

      show: true,
      phone: "",
      code: "",
      times: 60,
      currentResourceItem: null, // 存储当前资源项
      literatureDialogVisible: false,
      literatureItem: null,
      literatureForm: {
        email: "",
      },
      literatureRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
      },
      paperData: "",
    };
  },
  mounted() {
    this.imgUrl = baseurl.fileUrl;
    this.sid = this.$route.query.sid;
    if (localStorage.getItem("roles")) {
      let roleArr = localStorage.getItem("roles").split(",");
      roleArr.forEach(element => {
        if (element == "other") {
          this.roles = false;
        }
      });
    }
    //点击空白关闭弹出
    document.addEventListener("click", this.bodyCloseMenus);

    this.getDetail();
    this.getInfo();
  },
  created() {},
  methods: {
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },
    getString(data) {
      if (!data || !data.length) return "";
      //return str1.join(' ; ')
      return data.toString().split(",").join(" ; ");
    },
    toHomeDetail(sid) {
      const url = this.$router.resolve({
        path: "/homeDetail",
        query: { sid: sid },
      });
      window.open(url.href, "_self");
    },
    // 馆藏资源跳转
    libdetailUrl(bookItem) {
      this.Resourcelist = false;
      if (this.detail.doi) {
        let doi = this.detail.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      if (bookItem.shortName == "DOAJ-Directory of Open Access Journals") {
        if (!this.detaildoi) {
          this.detaildoi = this.detail.title;
        }
        let str = '{"query":{"query_string":{"query":"' + this.detaildoi + '","default_operator":"AND"}},"track_total_hits":true}';
        let query = encodeURIComponent(str);
        window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
        return;
      } else {
        this.$http({
          url: "api/v1/wantbuyR/ebook/link?ebookSid=" + bookItem.sid + "&doi=" + this.detaildoi + "&openAlexId=" + this.detail.openAlexId,
          method: "GET",
        }).then(res => {
          if (res.code == 200) {
            window.open(res.data);
          }
        });
      }
    },
    handleChangeTab1(index) {
      this.tab1Index = index;
    },
    toUrl(item) {
      if (item.indexOf("apply/paper/resource") > 0) {
        this.getResourceDetail(item);
      } else {
        window.open(item);
      }
    },
    getMore() {
      this.moreFlag = true;
      this.detail.digestStr = this.detail.digest;
      this.$forceUpdate();
    },
    removeMore() {
      this.moreFlag = false;
      this.detail.digestStr = this.detail.digest.substr(0, 210) + "...";
      this.$forceUpdate();
    },
    getDetail() {
      this.loading = true;
      this.tab2Loading = true;
      this.$http({
        url: "api/v1/reception/journalpaper/detailPlug1?sid=" + this.sid,
        method: "GET",
      }).then(res => {
        this.loading = false;
        this.detail = res.data;
        this.doi = this.detail.doi;

        this.getWorkReference(this.detail.openAlexId); //文献网络
        this.getTopicsList();
        this.$nextTick(function () {
          if (this.detail.openAlexId) {
            this.getOpenAlexTree();
          }
        });
        this.getHingeWordArray(this.detail.hingeWord);

        //学术论坛提示 字段  true显示  false不显示
        // if (this.detail.forum) {
        //   this.wxFlag = true;
        // } else {
        //   this.wxFlag = false;
        // }

        if (this.detail.referenceWorkBo) {
          if (this.detail.referenceWorkBo.referenceUrlList) {
            this.referenceUrlList = this.splitData(this.detail.referenceWorkBo.referenceUrlList);
          }
        }
        if (this.detail.digest && this.detail.digest.length > 210) {
          this.detail.digestStr = JSON.parse(JSON.stringify(this.detail.digest.substr(0, 210) + "..."));
        } else {
          this.detail.digestStr = this.detail.digest;
        }
        if (this.detail.author) {
          let authorArray = [];
          this.detail.author.forEach(element => {
            authorArray.push(element.authorName);
          });
          this.authorNameStr = authorArray.toString();
        }

        if (localStorage.getItem("jyx_token")) {
          this.getShareResult();
        }
      });
    },
    getHingeWordArray(word) {
      if (word) {
        let array = word.split(";").filter(Boolean);
        this.detail.hingeWordArray = array;
      }
    },
    // 获取topics列表
    getTopicsList() {
      this.$http({
        url: "api/v1/reception/journalpaper/paperTopic?openAlexId=" + this.detail.openAlexId,
        method: "GET",
      }).then(res => {
        this.topicsList = res.data;
      });
    },
    getShareResult() {
      let postBody = {
        outSid: this.detail.sid,
        type: 2,
      };
      this.$http({
        url: "api/v1/usershare/shareResult",
        method: "post",
        data: postBody,
      }).then(res => {
        this.resultFlag = res.data;
      });
    },
    isCollectTips() {
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isCollect();
      });
    },
    // 收藏
    isCollect() {
      let postBody = {
        outSid: this.detail.sid,
        type: 2,
      };
      this.$http({
        url: `api/v1/usershare/collect`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data == 1) {
            window.location.href = `${baseurl.baseUrl}api/v1/sso/toAuthenticate?redirect=${this.$route.fullPath}`;
          } else {
            if (!this.detail.share) {
              this.$message.success("收藏成功");
            }
            // this.getList();
            // if (this.resultFlag) {
            //   this.$message.success("取消收藏成功");
            // } else {
            //   this.$message.success("收藏成功");
            // }
            this.getDetail();
          }
        }
      });
    },
    toTranslatetitle(text) {
      let postBody = {
        sid: this.detail.sid,
        title: text,
      };
      this.translateLoading1 = true;
      this.$http({
        url: "api/v1/reception/journalpaper/titleTranslate",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.translateLoading1 = false;
          this.translatetitle = res.data;
        }
      });
    },
    // 机器翻译
    toTranslate() {
      this.translateLoading = true;
      let postBody = {
        sid: this.detail.sid,
        digest: this.detail.digest,
      };
      this.$http({
        url: `api/v1/reception/journalpaper/translate/paper`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.translateLoading = false;
          this.translatePaper = res.data;
        }
      });
    },
    // 收起翻译
    closeTranslate() {
      this.translatePaper = "";
    },
    closeTranslate1() {
      this.translatetitle = "";
    },
    toSearch() {
      this.$router.push({ path: "/articleSearch" });
    },
    toArticle() {
      this.$router.push({ path: "/article" });
    },
    gethttp(val) {
      if (val.indexOf("http") == 0) {
        return true;
      }
    },
    //获取全文
    getResource(item) {
      // 1, “馆藏”
      // 2, “OA”
      // 3, “非馆藏非OA”
      // 5, “采购”
      // 10, “未登录”
      if (this.btnLoading) {
        return;
      }
      this.btnLoading = true;
      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      let postBody = {
        doi: this.detaildoi,
        openAlexId: item.openAlexId,
      };
      this.$http({
        url: "api/v1/wantbuyR/queryPaper",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.btnLoading = false;

        // 是否显示文献传递的提示
        // if (!this.detail.isPdf) {
        //   this.wxFlag = true;
        // }

        if (res.data) {
          this.paperData = res.data;
          this.qingqiuhuoqu = false;
          this.Resourcelist = false;
          this.gainResource = {};
          this.liblist = [];
          if (res.data.state == 1) {
            this.Resourcelist = res.data.openAlexId;
            this.liblist = res.data.ebookNameList;
            this.achieveloading = false;
          } else if (res.data.state == 2) {
            // 显示请求获取按钮
            this.Resourcelist = res.data.openAlexId;
            this.qingqiuhuoqu = true;
            this.achieveloading = false;
          } else if (res.data.state == 3) {
            this.Resourcelist = res.data.openAlexId;
            this.gainResource = res.data.gainResourceBo;
            if (res.data.gainResourceBo.provideType === 4) {
              this.Resourcelist = false;
              this.$message.error("馆外无法获取资源");
              this.achieveloading = false;
              return;
            }
            this.achieveloading = false;
          } else if (res.data.state == 63) {
            window.open(
              `http://lib.cqu.edu.cn/articlesearch/web_searchingResult?key={"rule":{"ruleBody":"DI=[@DI_79107149_0_f]","ruleParameters":[{"key":"@DI_79107149_0_f","value":"${this.detaildoi}"}]},"filterRule":{"ruleBody":"TY=[@TY_96453382_0_f]","ruleParameters":[{"key":"@TY_96453382_0_f","value":"3"}]}}&keyword=${this.detaildoi}`,
            );
          } else if (res.data.state == 5 || res.data.state == 6 || res.data.state == 7) {
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.applyPaperSourceSid}&type=${res.data.state}`,
              method: "get",
            }).then(downres => {
              if (downres.code == 200) {
                // 采购下载
                if (res.data.state == 5) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/purchase/download?uid=" + downres.data);
                }
                // 文献传递下载
                if (res.data.state == 6) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/deliver/download?uid=" + downres.data);
                }
                // 个人上传文件下载
                if (res.data.state == 7) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/person/download?uid=" + downres.data + "&openAlexId=" + res.data.openAlexId);
                }
              }
            });
          } else if (res.data.state == 10) {
            // this.$router.push({ path: "/lg", query: { word: true } });
            this.$message.warning("该资源的全文仅限用户登录后获取，请先登录");
            // window.open(`/lg?word=true&isback=true`, "_self");
          } else if (res.data.state == 20) {
            //oa附件  下载附件
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.openAlexId}&type=${res.data.state}`,
              method: "get",
            }).then(res => {
              if (res.code == 200) {
                window.open(baseurl.baseUrl + "api/v1/wantbuyR/oa/download?uid=" + res.data);
              }
            });
          } else if (res.data.state == 52) {
            let title = "";
            let doi = "";
            if (res.data.doi) {
              doi = res.data.doi;
            } else {
              //个别数据会有\n 去除\n
              if (res.data.title.includes("\n")) {
                title = res.data.title.split("\n").join("");
              } else {
                title = res.data.title;
              }
              doi = title;
            }
            let str = '{"query":{"query_string":{"query":"' + doi + '","default_operator":"AND"}},"track_total_hits":true}';
            let query = encodeURIComponent(str);
            window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
          }
        }
      });
    },
    bodyCloseMenus(e) {
      if (this.Resourcelist) {
        this.Resourcelist = false;
      }
    },
    beforeDestroy() {
      document.removeEventListener("click", this.bodyCloseMenus);
    },
    //推荐
    recommendrecord(item) {
      this.Resourcelist = false;
      this.$http({
        url: "api/v1/advice/record/save/sys?openAlexId=" + item.openAlexId,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("推荐成功");
        } else {
          this.$message.error("推荐失败");
        }
      });
    },
    //跳转外部扩展链接
    literatureUrl(item) {
      this.Resourcelist = false;
      window.open(item);
    },
    // 文献传递
    getDeliverSave(val) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/deliver/apply/sys/save?openAlexId=" + val.openAlexId,
        method: "get",
      }).then(res => {
        window.open(`/asp/myDeliver`, "_self");
        // this.$message.success("文献传递成功，请到个人中心我的文献传递中查看~");
      });
    },
    // 文献请求获取 弹出一个弹框输入邮箱
    getLiterature(item) {
      this.Resourcelist = false;
      this.literatureItem = item;
      this.literatureForm.email = "";
      this.literatureDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.literatureFormRef) {
          this.$refs.literatureFormRef.clearValidate();
        }
      });
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.code == 200 && res.data && res.data.email) {
          this.literatureForm.email = res.data.email;
        }
      });
    },
    handleLiteratureClose() {
      this.$refs.literatureFormRef.resetFields();
      this.literatureDialogVisible = false;
    },
    submitLiterature() {
      this.$refs.literatureFormRef.validate(valid => {
        if (!valid) return;
        this.literatureDialogVisible = false;
        this.Resourcelist = false;
        this.$http({
          url: "/api/v1/literature-gain-apply/save",
          method: "POST",
          data: {
            paperSid: this.literatureItem.sid,
            email: this.literatureForm.email,
          },
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("请求获取成功，文献获取通知将发送到您的邮箱");
          }
        });
      });
    },
    // 百度学术
    goBaidu(url) {
      window.open(url);
    },
    // 请求获取
    getQingqiu(item) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/literature-gain-apply/save",
        method: "post",
        data: {
          paperSid: item.sid,
        },
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("请求成功，我们将在一天内进行处理，请您稍后在文献服务平台 - 我的申请 - 我的文献申请中获取!");
          this.qingqiuhuoqu = false;
        }
      });
    },
    getResourceDetail(item) {
      this.Resourcelist = false;
      this.currentResourceItem = item;
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (!res.data.phone) {
          this.code = "";
          this.phone = "";
          clearInterval(this.timer);
          this.show = true;
          this.phoneDialog = true;
          return;
        }
        if (item.doi) {
          this.detaildoi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        } else {
          this.detaildoi = "";
        }
        let postBody = {
          doi: this.detaildoi,
          openAlexId: item.openAlexId,
        };
        this.$http({
          url: "/api/v1/promote/wantbuy/getResource",
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.data.state == 2) {
            this.$message.success("您已提交过申请");
            return;
          }
          if (res.data.state == 3) {
            this.$message.success("订单是否有对应DOI,订购中");
            return;
          }
          if (res.data.state == 4) {
            this.$message.success("供应商暂不提供该资源");
            return;
          }
          if (res.data.state == 5) {
            this.$message.success("符合采选规则,获取成功");
            return;
          }
          // 不符合采选规则,待申请
          if (res.data.state == 6) {
            // 申请
            let dataBody = {
              doi: res.data.doi,
              title: res.data.title,
              paperPrice: res.data.paperPrice,
              singlePrice: res.data.singlePrice,
              totalPrice: res.data.totalPrice,
              badWord: res.data.badWord,
              supplierId: res.data.supplierId,
            };
            this.$http({
              url: "/api/v1/promote/wantbuy/apply",
              method: "POST",
              data: dataBody,
            }).then(respones => {
              this.$message.success(respones.data);
            });

            return;
          }
          if (res.data.state == 8) {
            //已提交过申请
            this.$message.success("资源被图书馆收录");
            return;
          }
          if (res.data.state == 21) {
            //系统繁忙
            this.$message.error("系统繁忙，请稍后重试");

            return;
          }
          if (res.data.state == 22) {
            //资源申请成功
            this.$message.success("资源申请成功，请在个人申请列表中查看");
            return;
          }
        });
      });
    },
    closeDialog(val) {
      this.stateDialogVisible = val;
    },
    // 参考文献更多
    handleMore() {
      var array = this.referenceUrlList[this.refIndex].join(";");
      this.$http({
        url: `api/v1/plug/referenceMore?referenceUrl=${array}`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.refIndex++;
          this.detail.referenceWorkBo.detailList = this.detail.referenceWorkBo.detailList.concat(res.data);
        }
      });
    },
    splitData(list) {
      var res = [];
      for (var i = 0, len = list.length; i < len; i += 5) {
        res.push(list.slice(i, i + 5));
      }
      return res;
    },
    handleUrl(index) {
      window.open(this.detail.referenceWorkBo.detailList[index].paperUrl);
    },
    handleChangeTab2(index) {
      this.tab2Index = index;
    },
    getOpenAlexTree() {
      this.$http({
        url: "/api/v1/reception/journalpaper/getConceptByOpenAlexId?openAlexId=" + this.detail.openAlexId,
        method: "GET",
      }).then(res => {
        this.treeData.push(res.data);
      });
    },

    openUrl(url) {
      window.open(url);
    },
    // 作者查看更多
    moreAuthor() {
      this.authorList = this.authorListMore;
    },
    showMore() {
      if (this.paperType == 10 || this.paperType == 20) {
        if (this.restList && this.restList.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.restWorkBoList && this.restWorkBoList.length > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 文献  查看更多
    morePaper() {
      let idx = 5;
      if (this.paperType == 10 || this.paperType == 20) {
        //每次查更多 取5个
        let array = this.restList.slice(0, idx);
        this.restList = this.restList.filter((item, index) => {
          return index > idx - 1;
        });
        let postBody = {
          workList: array,
        };
        this.$http({
          url: "/api/v1/reception/journalpaper/workMore",
          method: "post",
          data: postBody,
        }).then(res => {
          this.workDataBoList = this.workDataBoList.concat(res.data);
        });
      } else {
        //引证文献 每次查更多 取5个
        if (this.restWorkBoList && this.restWorkBoList.length > 0) {
          let array = this.restWorkBoList.slice(0, idx);
          this.restWorkBoList = this.restWorkBoList.filter((item, index) => {
            return index > idx - 1;
          });
          this.workDataBoList = this.workDataBoList.concat(array);
        }
      }
    },
    // topic-到详情
    toTopicDetail(index) {
      sessionStorage.setItem("topicWord", JSON.stringify(this.topicsList[index].description));
      let _url = this.$router.resolve({
        path: "/topicsearch",
      });
      window.open(_url.href, "_self");
    },
    //oa状态
    getColor(item) {
      return oaColor(item);
    },
    getoatext(item) {
      return oaText(item);
    },
    // 引用
    showReference() {
      this.dialogIndex = 1;
      this.$http({
        url: `api/v1/reception/journalpaper/getReference?sid=${this.detail.sid}`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.BIBObj = res.data.bib;
          this.CITEArray = [];
          if (res.data.mla) {
            this.CITEArray.push({
              name: "MLA",
              value: res.data.mla,
            });
          }
          if (res.data.apa) {
            this.CITEArray.push({
              name: "APA",
              value: res.data.apa,
            });
          }
          if (res.data.chicago) {
            this.CITEArray.push({
              name: "Chicago",
              value: res.data.chicago,
            });
          }
          if (res.data.gb) {
            this.CITEArray.push({
              name: "GB",
              value: res.data.gb,
            });
          }
          this.referenceDialog = true;
        }
      });
    },
    // 复制
    copyContent(val) {
      this.$copyText(val).then(
        () => {
          this.$message.success("复制成功");
          // 复制成功的操作
        },
        () => {
          this.$message.error("复制失败");
          // 复制失败的操作
        },
      );
    },
    // 导出
    handleExport(type) {
      let url = "";
      if (type == "bib") {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportBibTexReference?sid=" + this.detail.sid;
      } else {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportEndNoteReference?sid=" + this.detail.sid;
      }
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: localStorage.getItem("jyx_token"),
        },
        url,
      };

      Axios(options).then(res => {
        let blob = new Blob([res.data]);
        let objectUrl = URL.createObjectURL(blob); //创建下载的链接
        let a = document.createElement("a");
        a.href = objectUrl;

        // 获取文件名
        let fileName = type == "bib" ? "publication.bib" : "publication.enw";
        fileName = decodeURI(fileName);
        a.download = fileName; //设置文件名
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectUrl); //释放bolb对象
      });
    },
    changeDialogTab(index) {
      this.dialogIndex = index;
    },
    toJournalDetail() {
      let _url = this.$router.resolve({
        path: "/homeDetail",
        query: { sid: this.detail.journalSid },
      });
      window.open(_url.href, "_self");
    },
    toArticleSearch(item) {
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: item,
        }),
      );
      this.$router.push({
        path: "/article",
      });
    },
    toAi() {
      // let _url = this.$router.resolve({
      //   path: "/upload",
      //   query: { openAlexId: this.detail.openAlexId },
      // });
      // window.open(_url.href, "_blank");

      if (this.detail.isPdf) {
        window.open(`/asp/analysisdetail?paperSid=${this.detail.sid}&openAlexId=${this.detail.openAlexId}&openFlag=true&work=true`);
      } else {
        window.open(`/asp/?type=3&openFlag=true&work=true&jyx_token=${localStorage.getItem("jyx_token")}`);
      }
    },
    toPdf() {
      let routeUrl;
      if (window.__POWERED_BY_QIANKUN__) {
        const jyx_token = localStorage.getItem("jyx_token") || "";
        routeUrl = baseurl.baseUrl + `pdf?sid=${this.detail.sid}&openAlexId=${this.detail.openAlexId}&pdfType=${this.detail.isPdf}&jyx_token=${encodeURIComponent(jyx_token)}`;
      } else {
        const route = this.$router.resolve({
          path: "/pdf",
          query: {
            openAlexId: this.detail.openAlexId,
            pdfType: this.detail.isPdf,
            sid: this.detail.sid,
          },
        });
        routeUrl = route.href;
      }
      window.open(routeUrl, "_blank");
    },
    // 我要求助
    handleHelp() {
      let copydata = `?wxtitle=${encodeURIComponent(this.detail.title)}&wxauthor=${this.authorNameStr ? encodeURIComponent(this.authorNameStr) : "未知"}&wxjournalName=${this.detail.journalName ? encodeURIComponent(this.detail.journalName) : "未知"}&wxdoi=${
        this.detail.doi ? encodeURIComponent(this.detail.doi) : "未知"
      }`;
      try {
        navigator.clipboard.writeText(copydata).then(() => {
          // this.$message.success("已复制,您可随意粘贴使用");
          window.open("https://delivery.cxstar.cn/qaPage?action=ask-help");
        });
      } catch (err) {
        // 兼容旧浏览器的复制方式
        const textarea = document.createElement("textarea");
        textarea.value = copydata;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        // this.$message.success("已复制,您可随意粘贴使用");
        window.open("https://delivery.cxstar.cn/qaPage?action=ask-help");
      }
    },
    sureHelp() {
      window.location.href = `https://delivery.cxstar.cn/api/business/delivery/sso_seek?token=${localStorage.getItem("jyx_token")}&title=${encodeURIComponent(this.detail.title)}&author=${this.authorNameStr ? encodeURIComponent(this.authorNameStr) : "未知"}&journalName=${
        this.detail.journalName ? encodeURIComponent(this.detail.journalName) : "未知"
      }&doi=${this.detail.doi ? encodeURIComponent(this.detail.doi) : "未知"}`;
    },
    // 作者详情跳转
    toAuthorDetail(item) {
      if (item.click) {
        let _url = this.$router.resolve({
          path: "/authorDetail",
          query: { authorSid: item.sid },
        });
        window.open(_url.href, "_self");
      }
    },
    // -------文献网络-----------
    getWorkReference(openAlexId) {
      this.$http({
        url: `api/v1/workReference/basic?openAlexId=${openAlexId}`,
        method: "GET",
      }).then(res => {
        this.tab2Loading = false;
        this.workReferenceDetail = res.data;
        this.citeBoList = res.data.citeBoList;
        this.timeScrollList = this.workReferenceDetail.yearList;
      });
    },
    // 文献点击事件
    handSpan(index) {
      let num = 0;
      this.citeBoList.forEach(element => {
        if (index == element.citeType) {
          num = element.count;
        }
      });
      if (num == 0) {
        return;
      }
      this.spanIndex = index;
      this.referenceTotal = num;
      this.referenceName = this.getReferenceType(this.spanIndex);
      // 获取文献列表
      this.getWorkReferenceList();
    },
    getReferenceType(val) {
      if (val == 1) {
        return "参考文献";
      }
      if (val == 2) {
        return "引证文献";
      }
      if (val == 3) {
        return "共引文献";
      }
      if (val == 4) {
        return "同被引文献";
      }
      if (val == 5) {
        return "二级参考文献";
      }
      if (val == 6) {
        return "二级引证文献";
      }
    },
    // 接收时间选择组件传过来的值
    childrenValue(val) {
      this.realYear = val; //选择的时间
      // 重新获取文献值
      this.getWorkReferenceVal();
    },
    getWorkReferenceVal() {
      let postBody = {
        openAlexId: this.detail.openAlexId,
        realYear: this.realYear,
        paperYear: this.workReferenceDetail.paperYear,
        referYear: this.workReferenceDetail.referYear,
        quoteYear: this.workReferenceDetail.quoteYear,
      };
      this.$http({
        url: `api/v1/workReference/year`,
        method: "POST",
        data: postBody,
      }).then(res => {
        this.workReferenceDetail = res.data;
        this.citeBoList = res.data.citeBoList;
        // 恢复初始状态
        this.reWorkDataBoList = [];
        this.restList = [];
        this.spanIndex = 7;
      });
    },
    // 点击文献获取文献列表
    getWorkReferenceList() {
      let postBody = {
        openAlexId: this.detail.openAlexId,
        realYear: this.realYear ? this.realYear : this.workReferenceDetail.paperYear,
        paperYear: this.workReferenceDetail.paperYear,
        referYear: this.workReferenceDetail.referYear,
        quoteYear: this.workReferenceDetail.quoteYear,
        citeType: this.citeBoList[this.spanIndex - 1].citeType,
      };
      this.$http({
        url: `api/v1/workReference/thesis/list`,
        method: "POST",
        data: postBody,
      }).then(res => {
        this.reWorkDataBoList = res.data.reWorkDataBoList;
        this.restList = res.data.restList;
        this.moreArticleFlag = false; //是否显示加载更多按钮标识
        if (this.reWorkDataBoList.length > 0) {
          this.reWorkDataBoList.forEach((element, index) => {
            if (element.authorSimilarList.length > 0) {
              this.$set(this.reWorkDataBoList[index], "authorAllArray", element.authorSimilarList);
              this.$set(this.reWorkDataBoList[index], "authorArray", element.authorAllArray.slice(0, 5));
            }
            element.showauthor = true; //作者展开收起标识
          });
        }
      });
    },
    //作者展开收起
    showauthor(index) {
      this.reWorkDataBoList[index].showauthor = false;
      this.reWorkDataBoList[index].authorArray = this.reWorkDataBoList[index].authorAllArray;
      this.$forceUpdate();
    },
    closeauthor(index) {
      this.reWorkDataBoList[index].showauthor = true;
      this.reWorkDataBoList[index].authorArray = [];

      for (let i = 0; i < 5; i++) {
        this.reWorkDataBoList[index].authorArray.push(this.reWorkDataBoList[index].authorSimilarList[i]);
      }
      this.$forceUpdate();
    },
    toDetail(item) {
      if (item.sid) {
        let _url = this.$router.resolve({
          path: "/articleDetail",
          query: { sid: item.sid },
        });
        window.open(_url.href, "_self");
      } else {
        if (item.detailUrl) {
          window.open(item.detailUrl);
        } else {
          let url = "https://doi.org/" + item.doi;
          window.open(url);
        }
      }
    },
    moreData() {
      // 如果超过50  只显示50个
      if (this.referenceTotal > 50) {
        if (this.reWorkDataBoList.length == 50) {
          this.moreArticleFlag = true; //是否显示标识   true 不显示
          return;
        } else {
          this.moreArticleFlag = false;
        }
      }

      let sliceArray = this.restList.slice(0, 5); //每次加载的五个
      let newArray = this.restList.slice(5); //剩余的个数
      this.restList = newArray;

      let postBody = {
        workList: sliceArray,
      };
      this.$http({
        url: `api/v1/reception/journalpaper/workMore`,
        method: "POST",
        data: postBody,
      }).then(res => {
        this.reWorkDataBoList = this.reWorkDataBoList.concat(res.data);

        if (this.reWorkDataBoList.length > 0) {
          this.reWorkDataBoList.forEach((element, index) => {
            if (element.authorSimilarList && element.authorSimilarList.length > 0) {
              this.$set(this.reWorkDataBoList[index], "authorAllArray", element.authorSimilarList);
              this.$set(this.reWorkDataBoList[index], "authorArray", element.authorAllArray.slice(0, 5));
            }
            element.showauthor = true; //作者展开收起标识
          });
        }
      });
    },
    //添加到文件夹
    handleChoiseFolder(index) {
      if (this.folderIndex === index || this.folderList[index].exist) {
        this.folderIndex = null;
        this.folderList[index].exist = false;
      } else {
        this.folderIndex = index;
      }
      this.checkFolder = true;
      this.foldershare = false;
    },
    cannalFolder() {
      this.folderList.shift();
    },
    // 新增文件夹
    submitAddFolder() {
      if (!this.folderList[0].name.trim()) {
        this.$message.error("请输入文件夹名称");
        return;
      }
      const newFolderName = this.folderList[0].name.trim(); // 保存新建文件夹名称
      let postBody = {
        name: newFolderName,
      };
      this.$http({
        url: "/api/v1/ai-service/folder/save",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("新增成功");
          let folderSid = this.folderSid ? this.folderSid : "";
          let foldershare = this.foldershare ? this.foldershare : "";
          // 现在可以使用then了
          this.getFolderList(folderSid, foldershare).then(() => {
            // 查找并选中刚刚新建的文件夹
            for (let i = 0; i < this.folderList.length; i++) {
              if (this.folderList[i].name === newFolderName) {
                this.folderIndex = i;
                this.checkFolder = true;
                break;
              }
            }
          });
          EventBus.$emit("reloadFolder", true);
        }
      });
    },
    // 新建文件夹
    newAddFolder() {
      if (this.folderList.length >= 20) {
        this.$message.error("最多可以创建20个文件夹");
        return;
      }
      if (this.folderList.length > 0) {
        if (!this.folderList[0].name.trim()) {
          return;
        }
      }

      const container = this.$refs.myScroll;
      container.scrollTo({
        top: 0, // 滚动到的位置
        behavior: "smooth", // 平滑滚动效果
      });

      this.folderList.unshift({ name: "", addFlag: true });
    },
    // 单独添加和多选添加共用 将文献添加到文件夹
    submitFolder() {
      if (!this.checkFolder && this.foldershare) {
        this.$message.success(`收藏成功`);
        this.addFodlerDialog = false;
        return;
      }
      // this.folderSid 有值 代表单独添加   没值就是多选添加
      let folderSid = this.folderIndex !== null && this.folderIndex !== undefined ? this.folderList[this.folderIndex].sid : "";
      let sidArray = this.folderSid;
      let postBody = {
        folderSid: folderSid,
        paperSid: sidArray,
      };
      this.$http({
        url: `/api/v1/ai-service/user-literature/collectAddPaper`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (this.folderIndex !== null && this.folderIndex !== undefined) {
          this.$message.success(`成功收藏到"${this.folderList[this.folderIndex].name}"文件夹下`);
        } else {
          this.$message.success(`收藏成功`);
        }
        this.getDetail();
        this.addFodlerDialog = false;
      });
    },
    // 添加文献到文件夹
    getFolderList(sid) {
      let formData = "";
      // 单个添加文件夹
      if (sid) {
        // document.body.click();
        this.folderSid = sid;
        this.foldershare = this.detail.share;
        formData = new FormData();
        formData.append("paperSid", sid);
      } else {
        this.folderSid = "";
      }

      // 返回Promise对象
      return new Promise(resolve => {
        this.$http({
          url: `/api/v1/ai-service/folder/paperOptionList`,
          method: "POST",
          data: formData,
        }).then(res => {
          this.folderList = res.data;
          this.folderIndex = null;
          this.checkFolder = false;
          this.addFodlerDialog = true;
          resolve(); // 成功时resolve
        });
      });
    },
    //复制引文
    copylist() {
      // 根据当前引文格式获取选中内容
      this.$http({
        url: "api/v1/wantbuyR/copy/context?sid=" + this.detail.sid,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          let copydata = res.data;
          try {
            navigator.clipboard.writeText(copydata).then(() => {
              this.$message.success("已复制,您可随意粘贴使用");
            });
          } catch (err) {
            // 兼容旧浏览器的复制方式
            const textarea = document.createElement("textarea");
            textarea.value = copydata;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.$message.success("已复制,您可随意粘贴使用");
          }
        }
      });
    },
    getCode() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      this.$http({
        url: `api/v1/tourist/check/repeat/mobile?mobile=${this.phone}`,
        method: "get",
      }).then(res => {
        if (res.data) {
          this.times = 60;
          let formData = new FormData();
          formData.append("mobilePhone", this.phone);

          this.$http({
            url: `api/v1/user/sendCode`,
            method: "POST",
            data: formData,
          }).then(res => {
            this.show = false;
            this.timer = setInterval(() => {
              this.times--;
              if (this.times === 0) {
                this.show = true;
                clearInterval(this.timer);
              }
            }, 1000);
          });
        } else {
          this.$message.error("该手机号已存在");
          return;
        }
      });
    },
    submitAddphone() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.code.trim()) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phone);
      formData.append("smsCode", this.code);
      this.$http({
        url: `api/v1/user/changephone`,
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.phoneDialog = false;
          // 绑定成功后自动再次调用getResourceDetail方法
          if (this.currentResourceItem) {
            this.getResourceDetail(this.currentResourceItem);
          }
        }
      });
    },
    // 在组件销毁前清除定时器
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 138px);
  .w1380 {
    width: calc(100% - 40px);
    max-width: 1380px;
    min-width: 0;
    margin: 0 auto;
    nav {
      padding: 20px 0;
      font-size: 14px;
      color: #999999;
    }
    .main {
      margin-bottom: 30px;
      .info-left {
        flex: 1;
        min-width: 0;
        background: #fff;
        padding: 30px;
        color: #666666;
        .info-loading {
          min-height: 300px;
        }
      }
      .info {
        h2 {
          color: #333;
          font-weight: normal;
          font-size: 24px;
          margin-bottom: 10px;
          label {
            font-size: 14px;
            padding-left: 5px;
            width: 60px;
            line-height: 22px;
            text-align: center;
            color: white;
            font-weight: initial;
            padding: 2px 5px;
            margin-left: 5px;
          }
          img {
            margin-left: 5px;
            vertical-align: middle;
          }
        }
        .titleCn {
          font-size: 18px;
        }
        .journal_span {
          label {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .keyword_span {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        .green {
          color: #2d8cf0;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        .hover_a {
          cursor: pointer;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
        .more-a {
          cursor: pointer;
        }
        .info-author {
          label {
            margin-right: 5px;
          }

          .span-content {
            position: relative;
            .author-content {
              top: 30px;
              left: 0px;
            }
          }
          .green_span {
            cursor: pointer;
            &:hover {
              .span_a {
                text-decoration: underline;
              }
              transition: all 1s;
              .author-content {
                display: inline-block;
              }
            }
            .span_a {
              color: #2d8cf0;
            }
          }
          .author-content {
            position: absolute;
            background: #fff;
            box-shadow: 0 0 5px #d3d3d3;
            display: none;
            padding: 10px;
            z-index: 999999;
            top: -30px;
            right: -210px;
            min-width: 300px;
            .mb10 {
              font-size: 16px;
              margin-bottom: 10px !important;
            }
            .hui {
              margin-top: 5px !important;
              white-space: pre-wrap;
            }
            p {
              font-size: 14px;
              margin: 0 !important;
              line-height: 20px;
              span {
                position: relative;
                &:first-of-type {
                  margin-right: 14px;
                  &::before {
                    content: "";
                    position: absolute;
                    width: 1px;
                    height: 14px;
                    background: #ccc;
                    right: -7px;
                    top: 50%;
                    margin-top: -7px;
                  }
                }
                label {
                  color: #2d8cf0;
                }
              }
            }
          }
        }
        p {
          font-size: 16px;
          line-height: 30px;
          a {
            text-decoration: underline;
          }
        }
        .fanyi {
          color: #2d8cf0;
          .el-button {
            font-size: 16px;
          }
        }
        .btnList {
          margin-top: 20px;
          i {
            margin-right: 5px;
          }
        }
      }
      .relative {
        position: relative;
        .rotating-image {
          animation: rotate 1s linear infinite;
        }
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
      .achieve {
        background: #ffffff;
        border-radius: 2px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 45px;
        right: 0;
        z-index: 99999;
        cursor: text;
        &::after {
          content: "";
          position: absolute;
          top: -6px;
          right: 10px;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 10px solid #fff; /* 三角形的颜色 */
        }
        .achieve-li {
          min-width: 270px;
          max-width: 700px;
          overflow-y: auto;
          max-height: 200px;
          padding: 15px 20px;
        }

        li {
          font-size: 16px;
          line-height: 28px;
          padding: 0px;
          border-bottom: 0px;
          a {
            text-decoration: underline;
            color: #2d8cf0;
            cursor: pointer;
          }
          span {
            font-size: 14px;
            color: #b3b3b3;
            margin-left: 5px;
          }
          font {
            color: #b3b3b3;
            font-size: 12px;
            display: block;
            line-height: 20px;
            i {
              margin-right: 5px;
              color: #e6a23c;
            }
          }
          .el-icon-warning {
            color: #e6a23c;
            padding: 0px 10px;
            width: 30px;
          }
        }
      }
      .btnList {
        margin-top: 20px;
        background: #f7f7f7;
        height: 50px;
        line-height: 50px;
        display: flex;
        align-items: center;
        padding: 0 30px;
        .flex {
          display: flex;
          align-items: center;
          margin-left: 30px;
          cursor: pointer;
          img {
            margin-right: 5px;
          }
          &:hover {
            text-decoration: underline;
          }
          .hover-img {
            display: none;
          }
          &.collect-action {
            color: #2d8cf0;
          }
          &.article-action-active {
            color: #2d8cf0;
            .hover-img {
              display: inline-block;
            }
            .img {
              display: none;
            }
          }
        }
        span {
          // color: #2d8cf0;
          margin-left: 5px;
        }
        .btn-right {
          margin-left: auto;
          display: flex;
          align-items: center;
          .checked {
            color: #2d8cf0;
          }
          .pdf_img {
            width: 16px;
            height: 16px;
          }
          .noCourse {
            cursor: default !important;
          }
        }
      }
      .line {
        height: 1px;
        width: 100%;
        background: #e6e6e6;
        margin-top: 30px;
      }
      .referenceWork {
        background: #fff;
        margin-top: 20px;
        padding: 30px;
        color: #666;
        h3 {
          color: #333;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          span {
            font-size: 15px;
            margin-left: 5px;
          }
        }
        ul {
          li {
            margin-bottom: 10px;
            cursor: pointer;
            &:hover {
              color: #2d8cf0;
            }
            &:last-of-type {
              margin: 0;
            }
          }
        }
        .more {
          margin-top: 20px;
          i {
            margin-right: 5px;
          }
        }
      }
      .tab-content {
        background: #f7f7f7;
        margin-top: 30px;
        padding: 0 30px;
        color: #333;
        .tabs {
          padding: 20px 0;
          border-bottom: 1px solid #eee;
          font-weight: bold;
          display: flex;
          li {
            margin-right: 20px;
            cursor: pointer;
          }
          .checked {
            color: #2d8cf0;
          }
        }
        .displayItem {
          display: flex;
          flex-wrap: wrap;
          li {
            display: flex;
            align-items: center;
            padding: 10px 0px;
            width: 33.33%;
            cursor: pointer;
            color: #666;
            font-size: 16px;
            a {
              text-decoration: underline;
              color: #2d8cf0;
              cursor: pointer;
            }
            span {
              font-size: 14px;
              color: #b3b3b3;
            }
            .el-icon-warning {
              color: #e6a23c;
              padding: 0px 10px;
              width: 30px;
            }
          }
          img {
            width: 18px;
            margin-right: 5px;
          }
        }
      }
      .atlasTree {
        padding: 20px;
      }
      .noData {
        min-height: 200px;
        background: none;
      }
      .wxTips {
        margin-top: 30px;
        background: #fffbf6;
        border: 1px solid #ffd6a3;
        padding: 12px 20px;
        position: relative;
        a {
          color: #2d8cf0;
        }
        i {
          margin-right: 5px;
          color: #e6a23c;
        }
        .el-icon-close {
          color: #666;
          position: absolute;
          right: 5px;
          top: 5px;
          cursor: pointer;
        }
      }
      .wx-content {
        border-top: 1px solid #eeeeee;
        margin-top: 30px;
        padding-top: 30px;
        .tabs {
          display: flex;
          background: #f7f7f7;
          padding: 15px 30px;
          li {
            cursor: pointer;
            color: #333;
            font-weight: bold;
            margin-right: 30px;
          }
          .checked {
            position: relative;
            color: #2d8cf0;
            &::before {
              content: "";
              position: absolute;
              bottom: -15px;
              width: 100%;
              height: 2px;
              background: #2d8cf0;
              border-radius: 5px;
            }
          }
        }
        // 文献网络
        .relation-one {
          margin-top: 40px;
          text-align: center;
          .noCursor {
            cursor: default !important;
          }
          .checked {
            color: #2d8cf0;
          }
          div {
            margin-bottom: 30px;
            position: relative;
            .zuojiantou {
              width: 116px;
              height: 49px;
              position: absolute;
              left: 325px;
              top: 13px;
            }
            .youjiantou {
              width: 115px;
              height: 46px;
              position: absolute;
              right: 325px;
              top: -23px;
            }
          }
          .flex {
            align-items: center;
            justify-content: center;
            color: #333;
            span {
              background: #f0f7f7;

              &:nth-of-type(3) {
                background: #b8eaeb;
              }
            }
          }
          span {
            display: inline-block;
            text-align: center;
            width: 160px;
            height: 40px;
            line-height: 40px;
            border: 1px dashed #c2e8e8;
            cursor: pointer;
          }
          img {
            margin: 0 10px;
            width: 30px;
            height: 8px;
          }
          .cheng {
            background: #fcf4ed;
            border: 1px dashed #fcf4ed;
          }
        }
        .wx-loading {
          min-height: 250px;
        }
        .relation-two {
          margin-top: 40px;
        }
        .relation-three {
          color: #333;
          margin-top: 40px;
          h3 {
            font-size: 16px;
            margin-bottom: 10px;
          }

          li {
            padding: 20px;
            border-bottom: 1px dashed #ededed;
            &:hover {
              background: rgba(21, 186, 188, 0.04);
            }
            p {
              margin-bottom: 15px;
              &:nth-of-type(1) {
                cursor: pointer;

                &:hover {
                  background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
              }
              &:nth-of-type(2) {
                color: #666;
              }
            }
            .num {
              color: #999;
              font-size: 14px;
              span {
                margin-right: 30px;
              }
              label {
                color: #2d8cf0;
              }
            }
          }
          .more {
            color: #2d8cf0;
            padding-left: 20px;
            font-weight: normal;
          }
          .span-content {
            position: relative;
            .author-content {
              top: 30px;
              left: 0px;
            }
          }
          .digestLabel {
            cursor: pointer;
            margin-left: 10px;
            &:hover {
              color: #2d8cf0;
            }
          }
          .green_span {
            cursor: pointer;
            &:hover {
              .span_a {
                text-decoration: underline;
              }
              transition: all 1s;
              .author-content {
                display: inline-block;
              }
            }
            .span_a {
              color: #2d8cf0;
            }
          }
          .author-content {
            position: absolute;
            background: #fff;
            box-shadow: 0 0 5px #d3d3d3;
            display: none;
            padding: 10px;
            z-index: 999999;
            top: -30px;
            right: -210px;
            min-width: 300px;
            .mb10 {
              font-size: 16px;
              margin-bottom: 10px !important;
            }
            .hui {
              margin-top: 5px !important;
              white-space: pre-wrap;
            }
            p {
              font-size: 14px;
              margin: 0 !important;
              line-height: 20px;
              span {
                position: relative;
                &:first-of-type {
                  margin-right: 14px;
                  &::before {
                    content: "";
                    position: absolute;
                    width: 1px;
                    height: 14px;
                    background: #ccc;
                    right: -7px;
                    top: 50%;
                    margin-top: -7px;
                  }
                }
                label {
                  color: #2d8cf0;
                }
              }
            }
          }
        }

        .noData {
          min-height: 200px;
        }
        .more {
          color: #2d8cf0;
          margin-top: 15px;
          cursor: pointer;
          padding-left: 30px;
        }
      }
      .info-right-loading {
        min-height: 300px;
        width: 240px;
        background: #eeeeee;
      }

      .info-right {
        background: #eeeeee;
        width: 240px;
        padding: 30px;
        font-size: 14px;
        .mt10 {
          margin-top: 20px;
          margin-bottom: 10px !important;
        }
        .name {
          color: #666666;
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .title {
          margin-bottom: 10px;
          margin-top: 10px;
          color: #333;
          cursor: pointer;
          color: #2d8cf0;
        }
        p {
          color: #666;
          margin-bottom: 5px;
        }
        .img {
          width: 180px;
          height: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: #fff;
          margin-right: 20px;
          img {
            max-width: 178px;
            max-height: 178px;
          }
        }
        .topic {
          li {
            color: #666666;
            margin-bottom: 10px;
            cursor: pointer;
            text-decoration: underline;
            &:hover {
              color: #2d8cf0;
            }
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__header {
    background: #2d8cf0;
    height: 46px;
    line-height: 46px;
    padding: 0;
    padding-left: 30px;
    font-size: 18px;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      right: 15px;
      top: 12px;
      .el-dialog__close {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: left;
    padding-top: 0;
    padding-bottom: 30px;
    .down-dialog-footer {
      span {
        width: 80px;
        height: 30px;
        display: inline-block;
        text-align: center;
        line-height: 30px;
        margin-left: 10px;
        cursor: pointer;
        background: #f0f7f7;
        color: #2d8cf0;
        &:hover {
          background: #2d8cf0;
          color: #fff;
        }
      }
    }
  }
  .add_folder_dialog {
    ::v-deep .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      p {
        padding-left: 20px;
        cursor: pointer;
        i {
          margin-right: 5px;
        }
      }
    }
  }
  .dialog-content {
    .dialog-tab {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333;
      border-bottom: 1px solid #e6e6e6;
      li {
        padding-right: 10px;
        position: relative;
        padding: 0 10px;
        padding-bottom: 5px;
        cursor: pointer;
      }
      .dialogChecked {
        color: #2d8cf0;
        &::before {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          height: 2px;
          background: #2d8cf0;
          width: 100%;
        }
      }
    }
    .tab1 {
      margin-top: 20px;
      ul {
        max-height: 500px;
        overflow: auto;
        li {
          background: #f7f7f7;
          padding: 30px;
          margin-bottom: 10px;
          &:last-of-type {
            margin: 0;
          }
        }
      }
      ::-webkit-scrollbar {
        display: block;
        width: 8px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #d9d9d9;
      }
      ::-webkit-scrollbar-track {
        background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
      }

      .flex {
        align-items: center;

        span {
          margin-left: auto;
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #2d8cf0;
        }
      }
      .line {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
        label {
          color: #333;
          font-weight: bold;
        }
      }
      img {
        width: 17px;
        height: 16px;
        margin-right: 5px;
      }
      .dialog-info {
        color: #333333;
        line-height: 30px;
        margin-top: 20px;
        font-size: 16px;
        white-space: pre-wrap;
      }
    }
  }
  .helpDialog {
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }
  .tipsDialog {
    font-size: 15px;
    p {
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="scss">
.tool_box {
  color: #333;
  .tool_site {
    span {
      color: #2d8cf0;
    }
  }
  .tool_click {
    color: #2d8cf0;
    cursor: pointer;
  }
}
.add_dialog_folder {
  max-height: 400px;
  overflow-y: auto;
  ul {
    li {
      cursor: pointer;
      color: #333;
      .div_folder {
        height: 40px;
        border-radius: 5px;
        display: flex;
        padding: 0 20px;
        align-items: center;
      }
      .li_folder {
        justify-content: space-between;
        border: 1px solid #fff;
      }
      .new_folder {
        border: 1px solid #2d8cf0;
        .el-input {
          .el-input__inner {
            border: none;
            background: none;
            height: 25px;
            color: #333;
            padding: 0;
          }
        }
        span {
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          font-size: 16px;
          margin-left: 10px;
          i {
            color: #868686;
          }
        }
      }
      &:hover {
        background: #f5f6f7;
      }
      img {
        margin-right: 10px;
      }
      i {
        color: #2d8cf0;
        font-size: 18px;
      }
    }
  }
  .new_folder {
    ::v-deep .el-input__inner {
      /* 样式 */
      border: none !important;
      background: none;
      height: 25px;
      color: #333;
      padding: 0;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 20px 20px 50px 20px;
}
.phone {
  margin: 20px 0px;
  ::v-deep .el-input {
    .el-input__inner {
      padding-right: 120px;
    }
  }
  align-items: center;
  position: relative;
  .code {
    position: absolute;
    right: 15px;
    padding: 0 20px;
    color: #2d8cf0;
    top: 0;
    line-height: 38px;
    cursor: pointer;
    &::after {
      position: absolute;
      left: 0;
      width: 1px;
      height: 20px;
      background: #c9ebf7;
      content: "";
      top: 10px;
    }
  }
}
.phonebtn {
  display: flex;
  justify-content: flex-end;
}
.el-dialog__footer .dialog-footer-right {
  text-align: right;
  display: block;
}
.literature-dialog-content {
  .literature-tip {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.6;
  }
  .literature-tip-sm {
    font-size: 12px;
    margin-bottom: 20px;
    color: #ff0000;
  }
}

::v-deep .el-dialog {
  max-width: calc(100vw - 32px);
}

@media (max-width: 1100px) {
  .container .w1380 .main {
    flex-direction: column;

    .info-right-loading {
      width: 100%;
      min-height: 0;
      margin-top: 16px;
    }

    .info-right {
      width: 100%;
      display: grid;
      grid-template-columns: 180px minmax(0, 1fr);
      column-gap: 24px;
      padding: 24px;

      .name,
      .img {
        grid-column: 1;
      }

      .title,
      > p:not(.name),
      .topic {
        grid-column: 2;
      }

      .img {
        margin-right: 0;
      }
    }
  }
}

@media (max-width: 768px) {
  .container {
    min-height: 100vh;

    .w1380 {
      width: calc(100% - 24px);

      nav {
        padding: 12px 0;
      }

      .main {
        margin-bottom: 16px;

        .info-left {
          padding: 18px 14px;
        }

        .info {
          h2 {
            font-size: 21px;
            line-height: 1.5;
            overflow-wrap: anywhere;
          }

          .titleCn {
            font-size: 16px;
          }

          p {
            font-size: 14px;
            line-height: 24px;
            overflow-wrap: anywhere;

            a {
              overflow-wrap: anywhere;
            }
          }

          .fanyi .el-button {
            font-size: 14px;
          }

          .author-content {
            left: 0;
            right: auto;
            min-width: 0;
            width: min(300px, calc(100vw - 64px));
            box-sizing: border-box;
          }
        }

        .btnList {
          height: auto;
          min-height: 50px;
          align-items: flex-start;
          flex-direction: column;
          gap: 10px;
          padding: 14px;
          line-height: 24px;

          .btn-right {
            width: 100%;
            margin-left: 0;
            flex-wrap: wrap;
            gap: 10px 18px;

            .flex {
              margin-left: 0;
            }
          }
        }

        .achieve {
          left: 0;
          right: auto;
          max-width: calc(100vw - 52px);

          .achieve-li {
            min-width: 0;
            max-width: 100%;
            box-sizing: border-box;
          }
        }

        .wx-content {
          margin-top: 20px;
          padding-top: 20px;

          .tabs {
            padding: 12px 14px;
            overflow-x: auto;

            li {
              flex: 0 0 auto;
              margin-right: 22px;
              white-space: nowrap;
            }

            .checked::before {
              bottom: -12px;
            }
          }

          .relation-one {
            margin-top: 24px;
            overflow-x: auto;

            div {
              margin-bottom: 18px;
            }

            .flex {
              min-width: 720px;
            }

            .zuojiantou,
            .youjiantou {
              display: none;
            }

            span {
              width: 135px;
            }
          }

          .relation-two,
          .relation-three {
            margin-top: 24px;
          }

          .relation-three {
            li {
              padding: 16px 0;
            }

            .num {
              display: flex;
              flex-wrap: wrap;
              gap: 8px 16px;

              span {
                margin-right: 0;
              }
            }

            .author-content {
              left: 0;
              right: auto;
              min-width: 0;
              width: min(300px, calc(100vw - 64px));
              box-sizing: border-box;
            }
          }
        }

        .info-right {
          display: block;
          padding: 20px 14px;

          .img {
            width: 140px;
            height: 140px;

            img {
              max-width: 138px;
              max-height: 138px;
            }
          }
        }
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 18px 16px 30px;
  }

  .dialog-content .tab1 ul li {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .follow-btn-box .follow-btn {
    width: 100%;
    min-width: 0;
  }

  .phone {
    ::v-deep .el-input .el-input__inner {
      padding-right: 96px;
    }

    .code {
      padding: 0 10px;
    }
  }
}
</style>
